<div class="flex">
  <app-status
    *ngIf="!!status"
    [name]="name"
    [type]="type"
    [icon]="icon"
    [tooltip]="tooltip"
    [class.mr-8]="hasAnyIcon"
    [class]="statusClass"
  >
  </app-status>

  <app-status
    *ngIf="archiveStatus === archiveStatusType.ARCHIVED"
    [name]=""
    [type]="statusType.NEUTRAL"
    [icon]="'archive'"
    [class]="statusClass"
    [tooltip]="'Opłata pochodzi od zarchiwizowanego dostawcy'">

  </app-status>
  <app-status
    *ngIf="!!delegationData.targetEmail && showDelegationIcon"
    [name]=""
    [type]="statusType.PENDING"
    [icon]="'forward'"
    [class]="statusClass"
    [tooltip]="'Opłata przekazana do ' + delegationData.targetEmail"
  ></app-status>
  <app-liability-payment-reclassified-to-previous *ngIf="showReclassified">
  </app-liability-payment-reclassified-to-previous>
  <div class="flex"></div>
</div>



